/**
 * The app's store listings, in one place. Single-CTA spots use
 * preferredStoreUrl() so the link opens the store that matches the visitor's
 * device; layouts with room (hero, final CTA) show both badges explicitly.
 */
// UTM-tagged so Play Console's acquisition report credits installs to the website.
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=co.orthodoxway.app&utm_source=orthodoxway.co&utm_medium=website&utm_campaign=website';
export const APP_STORE_URL = 'https://apps.apple.com/app/orthodox-way/id6788000137';

function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  // iPadOS ≥13 reports itself as "Macintosh"; the touch check tells it apart
  // from a real Mac.
  return /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
}

/**
 * The store this visitor's device installs from. iOS/iPadOS → App Store;
 * everything else (Android, desktop) keeps the pre-iOS-launch default of
 * Google Play.
 */
export function preferredStoreUrl(): string {
  return isIOS() ? APP_STORE_URL : PLAY_STORE_URL;
}
